<template>
  <div class="education-wrapper">
    <!-- education list -->
    <div class="education-widget" v-if="is_items_list_open">
      <ul class="education-items" v-if="profile_data.educations.length > 0">
        <li class="education-starter">
          <div class="education-item-header">
            <label
              >Educations ({{
                profile_data.educations.length | validate
              }})</label
            >
            <button class="btn-add" @click="addUpdateForm()">
              Add Education +
            </button>
          </div>
        </li>
        <li
          class="education-item"
          v-for="(item, i) in profile_data.educations"
          :key="i"
        >
          <panel-expand>
            <template v-slot:header="{ options }">
              <div
                class="education-item-header"
                :class="{ no_expand: !options.expanded }"
                @click="options.expanded = true"
              >
                <div class="education-item-brand">
                  <img src="@/assets/icons/icon__edication.svg" alt />
                </div>
                <div class="content">
                  <div class="title-row">
                    <label>{{ item.organization | validate }}</label>
                    <span>{{ item.degree | validate }}</span>
                    <span class="date">
                      <span v-if="item.from">{{
                        item.from | formatDate | validate
                      }}</span>
                      <span class="separator" v-if="item.from && item.to"
                        >-</span
                      >
                      <span v-if="item.to">{{
                        item.to | formatDate | validate
                      }}</span>
                    </span>
                  </div>
                  <div class="options">
                    <dropdown-menu>
                      <ul>
                        <li>
                          <a href @click.prevent="editEducation(item)"
                            >Edit Education</a
                          >
                        </li>
                        <li>
                          <a href @click.prevent="deleteEducation(item.id, i)"
                            >Delete Education</a
                          >
                        </li>
                      </ul>
                    </dropdown-menu>

                    <button
                      class="toogle-panel-btn"
                      @click="options.expanded = !options.expanded"
                      v-if="!options.expanded"
                    >
                      <img src="@/assets/admin-icon/icon-down.svg" />
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:main="{ options }">
              <div class="education-item-body">
                <div class="education-info">
                  <h5>Location</h5>
                  <p>
                    <span v-if="item.address">{{
                      item.address | validate
                    }}</span>
                  </p>
                </div>
                <div class="education-item-body-option">
                  <button
                    class="toogle-panel-btn"
                    @click="options.expanded = !options.expanded"
                  >
                    <img src="@/assets/icons/up.svg" />
                  </button>
                </div>
              </div>
            </template>
          </panel-expand>
        </li>
      </ul>
      <div class="empty-widget" v-else>
        <div class="empty-widgetheader">
          <label>Educations</label>
        </div>
        <div class="empty-widget-body">
          <p>
            You have not yet added educations yet,
            <br />Click below to add one
          </p>
          <button class="add-btn" @click="addUpdateForm()">
            Add education
          </button>
        </div>
      </div>
    </div>

    <!-- Add and update form -->
    <div class="add-update-form" v-if="add_update_form">
      <div class="form-add">
        <span v-if="!education.id">Add New Education</span>
        <span v-else>Update Education</span>
        <label>Institution</label>
        <input
          type="text"
          placeholder="E.g.  Havard University"
          v-model="education.organization"
        />
        <label>Degree</label>
        <input
          type="text"
          placeholder="E.g.  Masters Degree in Business"
          v-model="education.degree"
        />
        <label>Time Frame</label>
        <div class="__row">
          <datepicker
            placeholder="From"
            v-model="education.from"
            input-class="input date-picker"
            wrapper-class="input"
          ></datepicker>
          <div style="width: 20px; height: 10px"></div>
          <datepicker
            placeholder="To"
            v-model="education.to"
            :disabled-dates="{ to: education.from }"
            input-class="input date-picker"
            wrapper-class="input"
          ></datepicker>
        </div>

        <label>Location</label>
        <div class="__row">
          <map-helper v-model="education.address"></map-helper>
        </div>

        <div class="__btns">
          <consultfied-button
            class="btn-save"
            :loading="save_edication_loading"
            @click="saveEdication()"
            >Save</consultfied-button
          >
          <button class="btn-cancel" @click="closeAddUpdateForm()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import appDialog from "@/components/Dialog/AppDialog.vue";
import panelExpand from "@/components/Partials/panelExpand";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import Datepicker from "vuejs-datepicker";
import { eventBus } from "@/main";

import { mapGetters } from "vuex";
export default {
  name: "education",
  components: {
    appDialog,
    panelExpand,
    Datepicker,
    consultfiedButton,
  },
  data: () => {
    return {
      save_edication_loading: false,
      education: {
        id: null,
        organization: "",
        from: "",
        to: "",
        description: "",
        degree: "",
        country: 0,
        city: 0,
        address: "",
        completed_year: "",
        title: "",
        logoName: "",
        logo: null,
        logoUrl: "",
        type: "education",
      },
      add_update_form: false,
      is_items_list_open: true,
      show_verify: false,
      profile_data: {
        user: {},
        projects: [],
        skills: [],
        employment: [],
        educations: [],
        trainings: [],
        certifications: [],
      },
      id: null,
      company_id: null,
    };
  },
  mounted() {
    let vm = this;
    vm.id = vm.$route.params.id;
    vm.company_id = vm.$route.params.company_id;
    vm.getConsultantData(vm.id);
  },
  computed: {
    ...mapGetters(["getCountries", "getCities"]),
  },
  methods: {
    deleteEducation(id, i) {
      let vm = this;
      vm.$store
        .dispatch("COMPANY_CONSULTANT_DELETE_EDUCATION", {
          id: id,
          user_id: vm.id,
          type: "education",
        })
        .then((responce) => {
          if (i > -1) {
            vm.profile_data.educations.splice(i, 1);
          }
        })
        .catch((error) => {
          console.log({ error });
        });
    },
    editEducation(item) {
      let vm = this;
      vm.add_update_form = true;
      vm.is_items_list_open = false;
      vm.education.id = item.id;
      vm.education.organization = item.organization;
      vm.education.from = vm.$dateObj(item.from);
      vm.education.to = vm.$dateObj(item.to);
      vm.education.description = item.description;
      vm.education.degree = item.degree;
      vm.education.address = item.address;
      vm.education.completed_year = "";
      vm.education.title = "";
      vm.education.logoName = "";
      vm.education.logo = null;
      vm.education.logoUrl = "";
    },
    saveEdication() {
      let vm = this;
      vm.save_edication_loading = true;
      eventBus.$set(vm.education, "user_id", vm.id);
      if (!vm.education.id) {
        // Add new project
        vm.$store
          .dispatch("COMPANY_CONSULTANT_ADD_NEW_EDUCATION", vm.education)
          .then((responce) => {
            vm.save_edication_loading = false;
            vm.getConsultantData(vm.id);
          })
          .catch((error) => {
            vm.save_edication_loading = false;
            console.log({ error });
          });
      } else {
        // Update project
        vm.$store
          .dispatch("COMPANY_CONSULTANT_UPDATE_EDUCATION", vm.education)
          .then((responce) => {
            vm.save_edication_loading = false;
            vm.getConsultantData(vm.id);
          })
          .catch((error) => {
            vm.save_edication_loading = false;
            console.log({ error });
          });
      }
    },
    getConsultantData(id) {
      let vm = this;
      vm.$store
        .dispatch("GET_CONSULTANT_ALL_DATA", { id: id })
        .then((responce) => {
          vm.showItemsList();
          vm.profile_data = responce.data;
        })
        .catch((error) => {
          console.log({ error });
        });
    },
    loadCities(e) {
      this.$store.dispatch("GET_CITIES", { country: e.target.value });
    },
    addUpdateForm() {
      let vm = this;
      vm.add_update_form = true;
      vm.is_items_list_open = false;
    },
    closeAddUpdateForm() {
      let vm = this;
      vm.add_update_form = false;
      vm.is_items_list_open = true;
      vm.education = {
        id: null,
        organization: "",
        from: "",
        to: "",
        description: "",
        degree: "",
        country: 0,
        city: 0,
        address: "",
        completed_year: "",
        title: "",
        logoName: "",
        logo: null,
        logoUrl: "",
      };
    },
    showItemsList() {
      let vm = this;
      vm.add_update_form = false;
      vm.is_items_list_open = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.education-wrapper {
  @media (min-width: 300px) and (max-width: 630px) {
    padding: 10px;
  }
  .education-widget {
    ul.education-items {
      padding: 0px 10px;
      padding-bottom: 20px;
      list-style: none;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      .education-starter {
        margin-bottom: 6px;
        .education-item-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 10px;
          label {
            color: #000000;
            font-family: "AvenirBook";
            font-size: 16px;
          }
          .btn-add {
            color: #1ba5a4;
            border: none;
            padding: 10px 10px;
            font-size: 14px;
            outline: none;
            cursor: pointer;
            font-family: "AvenirBook";
            font-style: italic;
            background: transparent;
          }
        }
        p {
          color: #131313;
          font-family: "AvenirBook";
        }
      }
      .education-item {
        background: #ffffff;
        border-radius: 5px;
        margin-bottom: 10px;
        position: relative;
        .education-item-header {
          display: grid;
          padding-top: 25px;
          padding-left: 25px;
          padding-right: 25px;
          grid-template-columns: 60px calc(97% - 60px);
          grid-column-gap: 20px;
          &.no_expand {
            padding-bottom: 25px;
            &:hover {
              cursor: pointer;
              background: #e9e9e9;
              border-radius: 4px;
            }
          }
          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 100%;
            grid-column-gap: 10px;
            padding: 10px 12px;
          }
          .education-item-brand {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 60px;
            height: 60px;
            background: rgb(228, 228, 228);
            border-radius: 50%;
            @media (min-width: 300px) and (max-width: 630px) {
              width: 60px;
              height: 60px;
              display: none;
            }
            img {
              width: 54px;
              height: 54px;
              object-fit: contain;
              @media (min-width: 300px) and (max-width: 630px) {
                width: 33px;
                height: 33px;
              }
            }
          }

          .content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .title-row {
              font-family: "AvenirBook";
              padding-right: 9px;
              display: flex;
              flex-direction: column;
              justify-content: center;

              label {
                display: block;
                font-size: 14px;
                font-family: "AvenirBook";
                margin-bottom: 5px;
                font-weight: 800;
                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 12px;
                }
              }

              span {
                color: #808080;
                font-family: "AvenirBook";
                font-size: 13px;
                margin-bottom: 6px;
                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 12px;
                }
              }
            }
            .options {
              display: flex;
              align-items: flex-end;
              flex-direction: column;
              .btns {
                display: flex;
              }
              .verified-status {
                color: #0590ab;
                margin: 10px 0px;
              }
              .btn-verify {
                height: 40px;
                width: 100px;
                outline: none;
                color: #fff;
                background-color: #1890a9;
                border-radius: 5px;
              }
              .date {
                color: #808080;
                font-family: "AvenirBook";
                font-size: 13px;
                display: flex;
                justify-content: flex-end;
                width: 188px;
                align-items: center;
                margin-bottom: 22px;
                .separator {
                  margin: 0px 5px;
                }
                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 11px;
                  width: 145px;
                }
              }

              .status {
                color: #000;
                font-family: "AvenirBook";
                font-size: 13px;
              }

              .toogle-panel-btn {
                width: 19px;
                padding: 0;
                height: 22px;
                font-size: 20px;
                position: absolute;
                bottom: 5px;
                right: 20px;
              }
            }
          }

          .toogle-panel-btn {
            padding: 1px 40px;
            font-size: 30px;
            background: transparent;
            border: none;
            outline: none;
            cursor: pointer;
            color: #ccc;
          }
        }
        .education-item-body {
          padding-bottom: 25px;
          padding-left: 25px;
          padding-right: 25px;
          .education-info {
            h5 {
              text-align: left;
              color: #6e6e6e;
              font-size: 14px;
              margin-bottom: 5px;
            }
            p {
              text-align: left;
              color: #000;
              font-size: 13px;
              font-weight: 800;
              margin-top: 0px;
            }
            .collaboraters-widget {
              padding: 10px 0px;
              display: flex;
              flex-wrap: wrap;
              .item {
                background: #1ba5a4 0% 0% no-repeat padding-box;
                border-radius: 20px;
                display: flex;
                align-items: center;
                padding: 4px 4px;
                margin-right: 8px;
                margin-bottom: 8px;
                .profile-img {
                  width: 26px;
                  height: 26px;
                  border-radius: 50%;
                  margin-right: 5px;
                }
                .name {
                  color: #fff;
                }
              }
            }
            .skills-widget {
              .skills_content__wrapper {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-column-gap: 10px;
                margin-bottom: 10px;
                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 1fr;
                }
                .skill_box {
                  min-width: 0;
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  background: #fff;
                  border-radius: 5px;
                  margin-bottom: 15px;
                  .skill_box_header {
                    border-bottom: 2px solid #f5f5f5;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    padding: 0px 15px;
                    label {
                      color: #0884af;
                      width: 100%;
                      font-size: 15px;
                      font-weight: 800;
                    }
                  }
                  .skill_box_body {
                    padding: 0px 15px;
                    .empty-skills {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      height: 200px;
                      justify-content: center;
                      p {
                        text-align: center;
                        margin-bottom: 20px;
                        color: #8d8d8d;
                      }
                      button {
                        width: 133px;
                        height: 36px;
                        background: #1890a9 0% 0% no-repeat padding-box;
                        border-radius: 5px;
                        color: #fff;
                      }
                    }
                    .row__item {
                      margin-top: 10px;
                      display: flex;
                      margin-bottom: 10px;
                      justify-content: space-between;
                      width: 100%;
                      span {
                        color: #000000;
                        font-weight: normal;
                        margin-top: 2px;
                        font-size: 14px;
                        font-weight: 800;
                      }
                    }
                  }
                }
              }
              .next_skills_content__wrapper {
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-column-gap: 10px;
                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 1fr;
                }
                .skill_box {
                  min-width: 0;
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  background: #fff;
                  border-radius: 5px;
                  margin-bottom: 15px;
                  .skill_box_header {
                    border-bottom: 2px solid #f5f5f5;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    padding: 0px 15px;
                    label {
                      color: #0884af;
                      width: 100%;
                      font-size: 15px;
                      font-weight: 800;
                    }
                  }
                  .skill_box_body {
                    padding: 0px 15px;
                    .empty-skills {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      height: 200px;
                      justify-content: center;
                      p {
                        text-align: center;
                        margin-bottom: 20px;
                        color: #8d8d8d;
                      }
                      button {
                        width: 133px;
                        height: 36px;
                        background: #1890a9 0% 0% no-repeat padding-box;
                        border-radius: 5px;
                        color: #fff;
                      }
                    }
                    .row__item {
                      margin-top: 10px;
                      display: flex;
                      margin-bottom: 10px;
                      justify-content: space-between;
                      width: 100%;
                      span {
                        color: #000000;
                        font-weight: normal;
                        margin-top: 2px;
                        font-size: 14px;
                        font-weight: 800;
                      }
                    }
                  }
                }
              }
            }
          }
          .education-item-body-option {
            display: flex;
            justify-content: flex-end;
            .toogle-panel-btn {
              padding: 1px 9px;
              font-size: 30px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
              height: 36px;
              width: 19px;
              padding: 0;
              height: 22px;
              font-size: 20px;
              position: relative;
              top: -3px;
              right: 0px;
            }
          }
        }
      }
    }
    .empty-widget {
      background: #fff;
      padding: 20px;
      .empty-widget-body {
        height: 350px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        p {
          text-align: center;
          width: 270px;
        }
        .add-btn {
          width: 180px;
          height: 45px;
          background: #1890a9 0% 0% no-repeat padding-box;
          border-radius: 4px;
          color: #fff;
          outline: none;
          margin-right: 20px;
          display: center;
          justify-content: center;
        }
      }
    }
  }
  .verify-form {
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    @media (min-width: 300px) and (max-width: 630px) {
      padding: 0px;
    }
    .project-form {
      background: #f5f5f5;
      padding: 20px;
      @media (min-width: 300px) and (max-width: 630px) {
        padding-top: 18px;
        padding-left: 11px;
        padding-right: 11px;
        padding-bottom: 39px;
      }
    }
    .__label {
      margin-bottom: 8px;
      display: block;
    }
    .input-group {
      display: grid;
      input {
        width: 100%;
        height: 40px;
        background: #fff;
        padding: 0px 13px;
        border-radius: 5px;
        outline: none;
      }
    }
    .__btns {
      display: flex;
      width: 30%;
      margin-top: 30px;
      justify-content: space-between;
      .cancel {
        color: #1ba5a4;
        cursor: pointer;
        font-weight: normal;
        height: 30px;
        padding: 3px 20px;
        font-size: 14px;
      }
      .save {
        background: #1ba5a4;
        color: #fff;
        font-size: 14px;
        font-weight: normal;
        cursor: pointer;
        border-radius: 5px;
        height: 30px;
        padding: 3px 10px;
        &:disabled {
          background: #8d8d8d;
          opacity: 0.3;
        }
      }
    }
  }
  .add-update-form {
    .form-add {
      display: flex;
      flex-direction: column;
      padding-right: 20px;
      padding-left: 20px;
      padding-bottom: 50px;
      .__row {
        display: flex;
      }
      .__rowd {
        display: flex;
        margin-bottom: 20px;
        justify-content: space-between;
        span {
          color: #000000;
          font-size: 13px;
          font-weight: normal;
        }
        button {
          background: transparent;
          outline: none;
          color: #680404;
          width: 118px;
          margin-top: 25px;
          border-radius: 5px;
          border: 0.5px solid #7e0505;
          height: 27px;
          img {
            margin-left: 10px;
          }
        }
      }
      .__title {
        font-size: 21px;
        margin-top: 10px;
        color: #1ba5a4;
        font-weight: normal;
      }
      span {
        color: #000;
        font-size: 13px;
        margin-top: 30px;
      }
      h2 {
        font-size: 14px;
        font-weight: normal;
        margin-top: 20px;
      }
      label {
        font-size: 14px;
        color: #676767;
        margin-top: 20px;
        font-weight: normal;
        margin-bottom: 5px;
      }
      .top {
        margin-top: 10px;
      }
      .__colored {
        color: #1885ad !important;
        margin-top: 20px;
      }
      input,
      textarea,
      .input,
      select {
        background: #fff;
        font-size: 12px;
        resize: none;
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 0px 20px !important;
        outline: none;
        border-radius: 5px;
        border: 1px solid #ddd;
        color: #000;
        height: 45px;
      }

      select {
        width: 100%;
      }
      textarea {
        min-height: 80px;
        padding: 10px;
      }
      .__save {
        display: flex;
        margin-top: 20px;
        button {
          background: #1ba5a4;
          border: 0.21px solid #666666;
          border-radius: 5px;
          color: #fff;
          padding: 7px 35px;
          outline: none;
        }
        .__none {
          background: none;
          border: none;
          box-shadow: none;
          margin-left: 10px;
          color: #1ba5a4;
        }
      }
      .__btns {
        display: flex;
        width: 30%;
        margin-top: 30px;
        justify-content: space-between;
        .btn-cancel {
          color: #1ba5a4;
          cursor: pointer;
          font-weight: normal;
          height: 40px;
          padding: 3px 20px;
          font-size: 14px;
          width: 100px;
        }
        .btn-save {
          background: #1ba5a4;
          color: #fff;
          font-size: 14px;
          font-weight: normal;
          cursor: pointer;
          border-radius: 5px;
          height: 40px;
          width: 100px;
          padding: 3px 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          &:disabled {
            background: #8d8d8d;
            opacity: 0.3;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.date-picker {
  height: 45px;
}
</style>